import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-ic-demo",
  "use": "icon-ic-demo-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"icon-ic-demo\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 3a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v7.333a1 1 0 0 1-1 1H8.667v1.334h2a.667.667 0 1 1 0 1.333H5.333a.667.667 0 0 1 0-1.333h2v-1.334H3a1 1 0 0 1-1-1V3Zm8 3.667-3.5 2.02V4.646l3.5 2.02Z\" fill=\"#fff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol